import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';


@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnChanges {
  @Input() navbarHeight: Event | Number | undefined;
  // Added '{read: ElementRef}' to get the ElementRef and not the Component Mat-Toolbar
  @ViewChild('navBar', { read: ElementRef }) navBar: any;
  @ViewChild('logoSvg') logoSvg: any;

  isSmall$: Observable<boolean> = this.breakpointObserver.observe([
    Breakpoints.XSmall,
    Breakpoints.Small
  ])
    .pipe(
      map((result) => result.matches), shareReplay());

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnChanges() {
    this.setNavbarHeight(this.navbarHeight! as Number);
    this.setLogoWidth(this.navbarHeight! as Number);
  }

  setNavbarHeight(changePercentage: Number) {
    const topHeight = 120; // Nav height in pixels at Top of Page
    const minHeight = 50   // Nav height in pixels when page scrolled down
    const diffHeight = (topHeight - minHeight) * (Number(changePercentage) / 100);
    const height = topHeight - (diffHeight);
    if (this.navBar) this.navBar.nativeElement.style.height = height + 'px';
  }

  setLogoWidth(changePercentage: Number) {
    const max = 80; // Logo max-width in pixels at Top of Page
    const min = 40; // Logo max-width in pixels when page scrolled down
    const diffWidth = (max - min) * (Number(changePercentage) / 100);
    const width = max - (diffWidth);
    if (this.logoSvg) this.logoSvg.nativeElement.style.width = width + 'px';
  }

}
